import * as React from 'react';
import classNames from 'classnames';
import { Text } from '@wix/design-system';
import s from './CheckoutSummaryFooter.scss';
import { TFunction } from 'i18next';

interface CheckoutSummaryFooterProps {
  isSecondUpgrade: boolean;
  isChangePlan: boolean;
  t: TFunction;
}

const CheckoutSummaryFooterComp: React.FC<CheckoutSummaryFooterProps> = ({
  isSecondUpgrade,
  isChangePlan,
  t,
}) => {
  const showContent = !(isSecondUpgrade || isChangePlan);
  return showContent ? (
    <div
      className={classNames(s.subDisclaimer, s.guarantee)}
      data-testid="checkout-money-back"
    >
      <div className={s.iconWrapper}>
        <div className={s.moneyBack} />
      </div>
      <Text size="medium" weight="normal">
        {t('checkout.money_back_guarantee')}
      </Text>
    </div>
  ) : null;
};

export const CheckoutSummaryFooter = React.memo(CheckoutSummaryFooterComp);
